import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IMobileSecuritySettingsResult } from '../types/IMobileSecuritySettings';

export interface IGetMobileSecuritySettingsForSiteRequestParams {
  siteId: string;
}

export class GetMobileSecuritySettingsForSiteRequest extends Request<IGetMobileSecuritySettingsForSiteRequestParams, IMobileSecuritySettingsResult> {
    constructor(params: IGetMobileSecuritySettingsForSiteRequestParams) {
        super('getMobileSecuritySettingsForSite', params);
    }
}
